import { useContext } from 'react';
import { AppElementContext } from './AppElementContext';

/**
 * A hook to retrieve app element information.
 */
export const useAppElementSelector = () => {
  const { selector } = useContext(AppElementContext);

  return selector;
};
